/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @preferred
 * @module AviFieldsetModule
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AviFieldsetComponent } from './components';

@NgModule({
    declarations: [
        AviFieldsetComponent,
    ],
    exports: [
        AviFieldsetComponent,
    ],
    imports: [
        CommonModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AviFieldsetModule {}
